import React, { useCallback, useEffect, useRef, useState } from "react";
import { ChartGranulometria as ChartGraudo } from "../CadastroCaracterizacao/relatoriocaracterizacaoGraudoPrint";
import { ChartGranulometria as ChartMiudo } from "../CadastroCaracterizacao/relatoriocaracterizacaoMiudoPrint";
import RelatorioRAAPrint from "../CadastroRAA/RelatorioRAAPrint";
import RelatorioAdesividadePrint from "../CadastroAdesividade/RelatorioAdesividadePrint";
import { RelatorioMescla } from "../CadastroGranulometriaAsfalto/CadastroGranulometriaAsfalto";
import "./RelatorioCaracterizacaoPrint.css";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import useNomeArquivoPdf from "../Utils/useNomeArquivoPdf";

function imprimir(codigoRelatorio) {
  const nomeArquivo = String(codigoRelatorio || "").trim();
  if (nomeArquivo && nomeArquivo !== "-") {
    document.title = nomeArquivo;
  }

  window.addEventListener("afterprint", limparGraficosCompactosImpressao, { once: true });

  let style = document.getElementById("relatorio-caracterizacao-print-page-style");
  if (!style) {
    style = document.createElement("style");
    style.id = "relatorio-caracterizacao-print-page-style";
    document.head.appendChild(style);
  }

  style.textContent = `
    @page relatorioCaracterizacaoPrint {
      size: A4 portrait;
      margin: 0;
    }

    @page anexoCaracterizacao {
      size: A4 portrait;
      margin: 0;
    }

    @media print {
      .relatorio-caracterizacao-geral-print {
        page: relatorioCaracterizacaoPrint !important;
      }

      .folha-rosto-anexo {
  box-sizing: border-box !important;
  height: 297mm !important;
  min-height: 297mm !important;
  overflow: hidden !important;
  page: anexoCaracterizacao !important;
  padding: 7mm 9mm !important;
  width: 210mm !important;
  margin-left: auto !important;
  margin-right: auto !important;
  background: #fff !important;
}

.relatorio-anexo-completo {
  margin-left: auto !important;
  margin-right: auto !important;
}
  
    }
  `;

  window.print();
}

function limparGraficosCompactosImpressao() {
  document
    .querySelectorAll(".relatorio-caracterizacao-geral-print .grafico-compacto-print")
    .forEach((grafico) => grafico.classList.remove("grafico-compacto-print"));

  document.getElementById("relatorio-caracterizacao-print-page-style")?.remove();
}

function formatarDataBR(data) {
  if (!data) return "-";
  if (typeof data === "string" && data.includes("-")) {
    const [ano, mes, dia] = data.split("-");
    return `${dia}/${mes}/${ano}`;
  }
  if (data?.seconds) return new Date(data.seconds * 1000).toLocaleDateString("pt-BR");
  if (data?.toDate) return data.toDate().toLocaleDateString("pt-BR");
  return String(data);
}

function valor(dado) {
  return dado === "" || dado === null || dado === undefined ? "-" : dado;
}

function numero(valor) {
  if (valor === "" || valor === null || valor === undefined) return null;
  const n = Number(String(valor).replace(",", "."));
  return Number.isFinite(n) ? n : null;
}

function numeroBR(valor, casas = 1) {
  if (valor === "" || valor === null || valor === undefined) return "";
  const n = typeof valor === "number" ? valor : numero(valor);
  if (n === null) return "";
  return n.toLocaleString("pt-BR", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
}

const numerosPeneiras = {
  "76.2": '3"',
  "63.5": '2" 1/2',
  "50.8": '2"',
  "38.1": '1" 1/2',
  "31.7": '1" 1/4',
  "25.4": '1"',
  "19": '3/4"',
  "12.5": '1/2"',
  "9.5": '3/8"',
  "6.3": '1/4"',
  "4.8": "Nº 4",
  "4.75": "Nº 4",
  "2.4": "Nº 8",
  "2.36": "Nº 8",
  "1.2": "Nº 16",
  "1.18": "Nº 16",
  "0.6": "Nº 30",
  "0.60": "Nº 30",
  "0.3": "Nº 50",
  "0.30": "Nº 50",
  "0.15": "Nº 100",
  fundo: "Fundo",
};

const peneirasRelatorio = {
  graudo: new Set(["31.7", "25.4", "19", "12.5", "9.5", "6.3", "4.8", "4.75", "2.4", "2.36"]),
  miudo: new Set(["9.5", "6.3", "4.8", "4.75", "2.4", "2.36", "1.2", "1.18", "0.6", "0.60", "0.3", "0.30", "0.15"]),
};

const peneirasPadraoRelatorio = {
  graudo: ["31,7", "25,4", "19,0", "12,5", "9,5", "6,3", "4,8", "2,4"],
  miudo: ["9,5", "6,3", "4,8", "2,4", "1,2", "0,6", "0,3", "0,15"],
};

const aberturaRelatorio = {
  "4.75": "4,8",
  "2.36": "2,4",
  "1.18": "1,2",
  "0.6": "0,6",
  "0.3": "0,3",
};

const normasReferenciaPadraoRelatorio = {
  granulometria: "NBR 17054/2022 - Determinação da Composição Granulométrica",
  densidade: "NBR NM 16917/2021 - Agregado Graúdo - Determinação da densidade e da absorção de água",
  massaUnitaria: "NBR 16972/2021 - Determinação da massa unitária e do índice de vazios",
  torroesArgila: "NBR 7218/2025 - Determinação do teor de argila em torrões e materiais friáveis",
  materialPulverulento: "NBR 16973/2021 - Determinação do material fino que passa pela peneira de 75 µm por lavagem",
  abrasaoLosAngeles: "ABNT NBR 7211/2022 - Ensaio de desgaste por Abrasão “Los Angeles”",
  indiceForma: "ABNT NBR 7809/2019 - Agregado graúdo - Determinação do índice de forma pelo método do paquímetro",
  impurezasOrganicas: "NBR NM 49/2001 - Agregado miúdo - Determinação de impurezas orgânicas",
  equivalenteAreia: "ABNT NBR 12052 - Solo ou agregado miúdo - Determinação do equivalente de areia",
  particulasLeves: "ABNT NBR 7211/2022 - Teor de Partículas Leves (Matérias Carbonosos)",
  saisCloretosSulfatos: "Determinação de Sais, Cloretos (Cl-) e Sulfatos Solúveis (SO42-)",
};

function chavePeneira(peneira) {
  const texto = String(peneira || "").trim();
  return texto.toLowerCase() === "fundo" ? "fundo" : String(numero(texto));
}

function numeroPeneira(linha) {
  if (linha.numeroPeneira) return linha.numeroPeneira;
  return numerosPeneiras[chavePeneira(linha.peneira)] || "-";
}

function linhasGranulometriaRelatorio(linhas, tipoAgregado) {
  let acumuladaA = 0;
  let acumuladaB = 0;
  const tipo = tipoAgregado === "miudo" ? "miudo" : "graudo";
  const peneirasVisiveis = peneirasRelatorio[tipo];
  const linhasPorPeneira = new Map(
    linhas
      .filter((linha) => peneirasVisiveis.has(chavePeneira(linha.peneira)))
      .map((linha) => [chavePeneira(aberturaRelatorio[chavePeneira(linha.peneira)] || linha.peneira), linha])
  );

  return peneirasPadraoRelatorio[tipo].map((peneira) => {
    const linha = linhasPorPeneira.get(chavePeneira(peneira)) || { peneira };
    const retidaA = numero(linha.retidaA);
    const retidaB = numero(linha.retidaB);

    if (retidaA !== null) acumuladaA += retidaA;
    if (retidaB !== null) acumuladaB += retidaB;

    return {
      ...linha,
      numeroPeneiraRelatorio: numeroPeneira(linha),
      aberturaRelatorio: aberturaRelatorio[chavePeneira(linha.peneira)] || linha.peneira,
      acumuladaARelatorio: linha.acumuladaA || (retidaA !== null ? numeroBR(acumuladaA, 1) : linha.acumulada),
      acumuladaBRelatorio: linha.acumuladaB || (retidaB !== null ? numeroBR(acumuladaB, 1) : linha.acumulada),
    };
  });
}

function codigoMaterial(item) {
  return item.codigoFornecedor || item.fornecedorCodigo || item.codigoMaterial || item.codigo || "-";
}

function ensaioSolicitado(item, ensaioId) {
  return Array.isArray(item?.ensaiosSolicitados) && item.ensaiosSolicitados.includes(ensaioId);
}

function mediaValores(...valores) {
  const numeros = valores.map(numero).filter((n) => n !== null);
  if (!numeros.length) return "";
  return numeroBR(numeros.reduce((soma, n) => soma + n, 0) / numeros.length, 3);
}

function particulasLevesPreenchidas(leves = {}) {
  const massaSolucao = String(leves.massaEspecificaSolucao || "").trim();
  return Boolean(
    leves.data &&
      (
        String(leves.teor || "").trim() !== "" ||
        (massaSolucao !== "" && massaSolucao !== "2,00" && massaSolucao !== "2.00")
      )
  );
}

function possuiGranulometriaCadastrada(item) {
  const linhas = linhasGranulometriaRelatorio(
    Array.isArray(item.granulometria) ? item.granulometria : [],
    item.tipoAgregado
  );

  return linhas.some(
    (linha) =>
      numero(linha.massaA) !== null ||
      numero(linha.massaB) !== null ||
      numero(linha.retidaA) !== null ||
      numero(linha.retidaB) !== null ||
      numero(linha.acumulada) !== null
  );
}

function diametroMaximo(item) {
  const linhas = linhasGranulometriaRelatorio(
    Array.isArray(item.granulometria) ? item.granulometria : [],
    item.tipoAgregado
  );

  if (!possuiGranulometriaCadastrada(item)) {
    return "";
  }

  if (item.diametroMaximo) {
    return item.diametroMaximo;
  }

  const linha = linhas.find((l) => {
    const acumulada = numero(l.acumulada);
    return acumulada !== null && acumulada > 5;
  });

  if (!linha) {
    return "";
  }

  const anterior = linhas[Math.max(0, linhas.indexOf(linha) - 1)];

  return anterior?.aberturaRelatorio || "";
}
function notaCurvaGranulometrica(tipoAgregado) {
  const isMiudo = tipoAgregado === "miudo";
  return `De acordo com os itens 5.1.1 e 6.1.1 da ABNT NBR 7211/2022, a distribuição granulométrica, determinada segundo a ABNT NBR NM 17054, deve atender aos limites estabelecidos na Tabela ${isMiudo ? "2" : "6"}. Podem ser utilizados como agregado ${isMiudo ? "miúdo" : "graúdo"} para concreto materiais com distribuição granulométrica diferentes das zonas estabelecidas na referida Tabela, desde que estudos prévios de dosagem comprovem sua aplicabilidade.`;
}

function normaLinha(texto) {
  const valorNorma = String(texto || "").trim();
  if (!valorNorma) return null;
  const partes = valorNorma.split(/\s+-\s+/);
  if (partes.length < 2) return { codigo: "-", descricao: valorNorma };
  return { codigo: partes[0].trim(), descricao: partes.slice(1).join(" - ").trim() };
}

function normasReferenciaRelatorio(caracterizacoes = []) {
  const linhas = [];
  const vistos = new Set();

  caracterizacoes.forEach((item) => {
    const normas = {
      ...normasReferenciaPadraoRelatorio,
      ...(item.normaReferencia || {}),
    };
    const chaves = [];

if (possuiGranulometriaCadastrada(item) || ensaioSolicitado(item, "caracterizacao-granulometria")) {
  chaves.push("granulometria");
}

if (item.densidade?.densidadeMedia || item.dataDensidade || ensaioSolicitado(item, "caracterizacao-densidade-absorcao")) {
  chaves.push("densidade");
}

if (item.massaUnitaria?.mediaMassaUnitaria || item.dataMassaUnitaria || ensaioSolicitado(item, "caracterizacao-massa-unitaria")) {
  chaves.push("massaUnitaria");
}

if (item.torroesPulverulentos?.torroesPercentual || item.dataTorroesArgila || ensaioSolicitado(item, "caracterizacao-torroes-argila")) {
  chaves.push("torroesArgila");
}

if (item.torroesPulverulentos?.pulverulentosPercentual || item.dataMateriaisPulverulentos || ensaioSolicitado(item, "caracterizacao-materiais-pulverulentos")) {
  chaves.push("materialPulverulento");
}

if (item.tipoAgregado === "graudo" || ensaioSolicitado(item, "caracterizacao-abrasao-los-angeles") || ensaioSolicitado(item, "caracterizacao-indice-forma")) {
  if (
    item.abrasaoLosAngeles?.abrasaoPercentual ||
    item.dataAbrasaoLosAngeles ||
    ensaioSolicitado(item, "caracterizacao-abrasao-los-angeles")
  ) {
    chaves.push("abrasaoLosAngeles");
  }

  if (
    (item.indiceForma?.semEnsaio === false && (item.indiceForma?.resultado || item.indiceForma?.data)) ||
    ensaioSolicitado(item, "caracterizacao-indice-forma")
  ) {
    chaves.push("indiceForma");
  }
}

if (item.tipoAgregado === "miudo" || ensaioSolicitado(item, "caracterizacao-impurezas-organicas") || ensaioSolicitado(item, "caracterizacao-equivalente-areia")) {
  if (
    item.tipoAgregado === "miudo" && (
    item.impurezasOrganicas?.data ||
    item.impurezasOrganicas?.clarezaMaisClara ||
    item.impurezasOrganicas?.relacaoIgual ||
    item.impurezasOrganicas?.padraoMaisEscura ||
    ensaioSolicitado(item, "caracterizacao-impurezas-organicas")
    )
  ) {
    chaves.push("impurezasOrganicas");
  }

  if (item.equivalenteAreia?.data || item.equivalenteAreia?.media || ensaioSolicitado(item, "caracterizacao-equivalente-areia")) {
    chaves.push("equivalenteAreia");
  }
}

if (particulasLevesPreenchidas(item.particulasLeves || {}) || ensaioSolicitado(item, "caracterizacao-particulas-leves")) {
  chaves.push("particulasLeves");
}

if (
  item.saisCloretosSulfatos?.data ||
  item.saisCloretosSulfatos?.teorCloretos ||
  item.saisCloretosSulfatos?.teorSulfatos ||
  item.saisCloretosSulfatos?.teorSais ||
  ensaioSolicitado(item, "caracterizacao-sais-cloretos-sulfatos")
) {
  chaves.push("saisCloretosSulfatos");
}

    chaves.forEach((chave) => {
      const linha = normaLinha(normas[chave]);
      const assinatura = linha ? `${linha.codigo}|${linha.descricao}` : "";
      if (!linha || vistos.has(assinatura)) return;
      vistos.add(assinatura);
      linhas.push(linha);
    });
  });

  return linhas;
}

function SecaoTitulo({ numero, children }) {
  return <div className="titulo-secao">{numero} {children}</div>;
}

function Subtitulo({ numero, children, className = "" }) {
  const classeGranulometria = String(children).toLowerCase().includes("granul") ? "subtitulo-granulometria" : "";
  return <div className={`subtitulo-faixa ${classeGranulometria} ${className}`.trim()}>{numero} {children}</div>;
}

function descricaoEnsaioAnexo(anexo) {
  const ensaio = anexo.ensaio || {};
  if (anexo.tipo === "raa") {
    return ensaio.agregado || ensaio.fornecedor || "Agregado";
  }
  if (anexo.tipo === "mescla-granulometrica-cbuq") {
    return ensaio.material || "Mescla granulométrica";
  }
  return ensaio.material || ensaio.fornecedor || "Agregado";
}

function FolhaRostoAnexo({ numero, titulo, ensaios, relatorio, cliente, obra }) {
  return (
    <section className="folha-rosto-anexo">
      <table className="capa-anexo-cabecalho">
        <tbody>
          <tr>
            <td rowSpan="2" className="capa-anexo-logo">
              <LogoRelatorio alt="Logo"  />
            </td>
            <td className="capa-anexo-sgq">SISTEMA DE GESTÃO DA QUALIDADE</td>
            <td>Revisão 00</td>
          </tr>
          <tr>
            <td>Relatório de ensaio - Ensaio de Agregados para concreto</td>
            <td>05/02/2023</td>
          </tr>
        </tbody>
      </table>

      <div className="capa-anexo-data"><strong>DATA</strong> {formatarDataBR(relatorio?.data)}</div>
      <div className="capa-anexo-faixa" />
      <table className="capa-anexo-empresa">
        <tbody>
          <tr>
            <td><strong>EMPRESA:</strong></td>
            <td>{cliente?.nome || relatorio?.clienteNome || "-"}</td>
          </tr>
          <tr>
            <td><strong>LOCAL/OBRA:</strong></td>
            <td>{obra?.nome || relatorio?.obraNome || "-"}</td>
          </tr>
        </tbody>
      </table>
      <div className="capa-anexo-faixa" />

      <div className="capa-anexo-titulo">
        ANEXO {numero} - {String(titulo || "").toUpperCase()}
      </div>

      <table className="capa-anexo-relatorios">
        <thead>
          <tr>
            <th>Número do Relatório</th>
            <th>Agregado Utilizado</th>
          </tr>
        </thead>
        <tbody>
          {ensaios.map((anexo, index) => (
            <tr key={`${anexo.tipo}-${anexo.ensaio.id}-${index}`}>
              <td>{anexo.ensaio.codigo || "-"}</td>
              <td>{descricaoEnsaioAnexo(anexo)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="capa-anexo-assinatura">
        <img src="/Images/assinaturaLeal.png" alt="Assinatura" />
        <div>José Carlos Lemes Leal</div>
        <div>Eng. Civil CREA 203379/D-TO</div>
      </div>
    </section>
  );
}

function TabelaGranulometria({ item }) {
  const linhas = linhasGranulometriaRelatorio(
    Array.isArray(item.granulometria) ? item.granulometria : [],
    item.tipoAgregado
  );

  return (
    <table className="tabela-granulometria">
      <colgroup>
        <col className="col-peneira-numero" />
        <col className="col-peneira-abertura" />
        <col className="col-determinacao" />
        <col className="col-determinacao" />
        <col className="col-media" />
      </colgroup>
      <thead>
        <tr>
          <th colSpan="2">Peneiras</th>
          <th>1ª Determinação</th>
          <th>2ª Determinação</th>
          <th>Média</th>
        </tr>
        <tr>
          <th>Nº</th>
          <th>
            <span>Abertura</span>
            <span>mm</span>
          </th>
          <th>
            <span>% Retida</span>
            <span>Acumulada</span>
          </th>
          <th>
            <span>% Retida</span>
            <span>Acumulada</span>
          </th>
          <th>
            <span>% Retida</span>
            <span>Acumulada</span>
          </th>
        </tr>
      </thead>

      <tbody>
        {linhas.map((linha, i) => (
          <tr key={i}>
            <td>{valor(linha.numeroPeneiraRelatorio)}</td>
            <td>{valor(linha.aberturaRelatorio)}</td>
            <td>{valor(linha.acumuladaARelatorio)}</td>
            <td>{valor(linha.acumuladaBRelatorio)}</td>
            <td>{valor(linha.acumulada)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function TabelaDensidade({ item }) {
  const d = item.densidade || {};
  return (
    <table className="tabela-compacta">
      <tbody>
        <tr className="subtitulo">
          <td colSpan="4">Densidade e absorção - NBR 16917</td>
        </tr>
        <tr>
          <td>Data</td>
          <td>{formatarDataBR(item.dataDensidade)}</td>
          <td>Operador</td>
          <td>{valor(item.operadorDensidade)}</td>
        </tr>
        <tr>
          <td>Densidade média (sss)</td>
          <td className="valor">{valor(d.densidadeMedia)}</td>
          <td>Absorção 1 / 2 (%)</td>
          <td>{valor(d.absorcao1)} / {valor(d.absorcao2)}</td>
        </tr>
        <tr>
          <td>Densidade seco 1 / 2</td>
          <td>{valor(d.densidadeSeco1)} / {valor(d.densidadeSeco2)}</td>
          <td>Material seco 1 / 2</td>
          <td>{valor(d.materialSeco1)} / {valor(d.materialSeco2)}</td>
        </tr>
      </tbody>
    </table>
  );
}

function TabelaMassaUnitaria({ item }) {
  const m = item.massaUnitaria || {};
  return (
    <table className="tabela-compacta">
      <tbody>
        <tr className="subtitulo">
          <td colSpan="4">Massa unitária em estado solto - NBR 16972</td>
        </tr>
        <tr>
          <td>Data</td>
          <td>{formatarDataBR(item.dataMassaUnitaria)}</td>
          <td>Operador</td>
          <td>{valor(item.operadorMassaUnitaria)}</td>
        </tr>
        <tr>
          <td>Média da massa unitária</td>
          <td className="valor">{valor(m.mediaMassaUnitaria)}</td>
          <td>Ensaios 1 / 2</td>
          <td>{valor(m.massaUnitaria1)} / {valor(m.massaUnitaria2)}</td>
        </tr>
        <tr>
          <td>Massa agregado 1 / 2</td>
          <td>{valor(m.massaAgregado1)} / {valor(m.massaAgregado2)}</td>
          <td>Volume 1 / 2</td>
          <td>{valor(m.volume1)} / {valor(m.volume2)}</td>
        </tr>
      </tbody>
    </table>
  );
}

function TabelaTorroesPulverulentos({ item }) {
  const t = item.torroesPulverulentos || {};
  return (
    <table className="tabela-compacta">
      <thead>
        <tr className="subtitulo">
          <th></th>
          <th>Torrões de argila</th>
          <th>Material pulverulento</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Data</td>
          <td>{formatarDataBR(item.dataTorroesArgila)}</td>
          <td>{formatarDataBR(item.dataMateriaisPulverulentos)}</td>
        </tr>
        <tr>
          <td>Antes</td>
          <td>{valor(t.torroesAntes)}</td>
          <td>{valor(t.pulverulentosAntes)}</td>
        </tr>
        <tr>
          <td>Depois</td>
          <td>{valor(t.torroesDepois)}</td>
          <td>{valor(t.pulverulentosDepois)}</td>
        </tr>
        <tr>
          <td>%</td>
          <td className="valor">{valor(t.torroesPercentual)}</td>
          <td className="valor">{valor(t.pulverulentosPercentual)}</td>
        </tr>
      </tbody>
    </table>
  );
}

function TabelaResultadosCaracterizacao({ item }) {
  const d = item.densidade || {};
  const m = item.massaUnitaria || {};
  const t = item.torroesPulverulentos || {};
  const isMiudo = item.tipoAgregado === "miudo";
  const impurezas = item.impurezasOrganicas || item.impurezas || {};
  const equivalenteAreia = item.equivalenteAreia || {};
  const impurezasPreenchidas = Boolean(
    impurezas.data ||
    impurezas.clarezaMaisClara ||
    impurezas.clareza === "mais_clara" ||
    impurezas.relacaoIgual ||
    impurezas.relacao === "igual" ||
    impurezas.padraoMaisEscura ||
    impurezas.padrao === "mais_escura"
  );
  const possuiGranulometria = possuiGranulometriaCadastrada(item);
  const dataGranulometria = possuiGranulometria ? item.dataGranulometria : "";
  const moduloFinura = possuiGranulometria ? item.moduloFinura : "";
  const dataPulverulentos = item.dataMateriaisPulverulentos || item.dataMaterialPulverulento || item.dataTorroesArgila;
  const indiceForma = dadosIndiceForma(item);

  return (
    <table className="tabela-resultados-caracterizacao">
      <colgroup>
        <col className="col-ensaio" />
        <col className="col-unidade" />
        <col className="col-data" />
        <col className="col-resultado" />
        <col className="col-limite" />
      </colgroup>
      <thead>
        <tr>
          <th colSpan="2">Ensaios solicitados / realizados</th>
          <th>Data do ensaio</th>
          <th colSpan="2">Resultados</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Diâmetro Máximo</td>
          <td>mm</td>
          <td>{formatarDataBR(dataGranulometria)}</td>
          <td colSpan="2">{valor(diametroMaximo(item))}</td>
        </tr>
        <tr>
          <td>Módulo de Finura</td>
          <td>-</td>
          <td>{formatarDataBR(dataGranulometria)}</td>
          <td colSpan="2">{valor(moduloFinura)}</td>
        </tr>
        <tr>
          <td>Massa Unitária</td>
          <td>kg/m³</td>
          <td>{formatarDataBR(item.dataMassaUnitaria)}</td>
          <td colSpan="2">{valor(m.mediaMassaUnitaria)}</td>
        </tr>
        <tr>
          <td>Densidade</td>
          <td>g/cm³</td>
          <td>{formatarDataBR(item.dataDensidade)}</td>
          <td colSpan="2">{valor(d.densidadeMedia)}</td>
        </tr>
        <tr>
          <td>Absorção</td>
          <td>(%)</td>
          <td>{formatarDataBR(item.dataDensidade)}</td>
          <td colSpan="2">{valor(d.absorcaoMedia || mediaValores(d.absorcao1, d.absorcao2))}</td>
        </tr>
        {indiceForma.mostrar && (
          <tr>
            <td>Índice de forma</td>
            <td>-</td>
            <td>{formatarDataBR(indiceForma.data)}</td>
            <td colSpan="2">{valor(indiceForma.resultado)}</td>
          </tr>
        )}
        <tr>
          <td>Argila em Torrões</td>
          <td>(%)</td>
          <td>{formatarDataBR(item.dataTorroesArgila)}</td>
          <td>{valor(t.torroesPercentual)}</td>
          <td rowSpan="2" className="limite-nbr">
            <div>Limite Normativo NBR 7211: 3,00</div>
            <div>Concreto submetido a desgaste Superficial: 3,0 %.</div>
            <div>Concreto protegido a desgaste Superficial: 5,0 %.</div>
          </td>
        </tr>
        <tr>
          <td>Material Fino que passa na peneira 75 µm por lavagem (material Pulverulento)</td>
          <td>(%)</td>
          <td>{formatarDataBR(dataPulverulentos)}</td>
          <td>{valor(t.pulverulentosPercentual)}</td>
        </tr>
        {isMiudo && (
          <tr>
            <td>Impurezas Orgânicas:</td>
            <td>(%)</td>
            <td>{formatarDataBR(item.dataImpurezasOrganicas || impurezas.data)}</td>
            <td colSpan="2" className="impurezas-opcoes">
              {impurezasPreenchidas ? (
                <>
                  <div><span>Clareza em</span><strong>({impurezas.clarezaMaisClara || impurezas.clareza === "mais_clara" ? "X" : " "})</strong><span>mais clara</span></div>
                  <div><span>Relação ao</span><strong>({impurezas.relacaoIgual || impurezas.relacao === "igual" ? "X" : " "})</strong><span>igual</span></div>
                  <div><span>Padrão</span><strong>({impurezas.padraoMaisEscura || impurezas.padrao === "mais_escura" ? "X" : " "})</strong><span>mais escura</span></div>
                </>
              ) : (
                "-"
              )}
            </td>
          </tr>
        )}
        {(isMiudo || ensaioSolicitado(item, "caracterizacao-equivalente-areia")) && Boolean(
          equivalenteAreia.data ||
          equivalenteAreia.media ||
          ensaioSolicitado(item, "caracterizacao-equivalente-areia")
        ) && (
          <tr>
            <td>Equivalente de areia</td>
            <td>%</td>
            <td>{formatarDataBR(equivalenteAreia.data)}</td>
            <td colSpan="2">{valor(equivalenteAreia.media)}</td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

function FotosEquivalenteAreia({ item }) {
  const equivalenteAreia = item.equivalenteAreia || {};
  const fotos = [
    { legenda: "ANTES", foto: equivalenteAreia.fotoAntes },
    { legenda: "DEPOIS", foto: equivalenteAreia.fotoDepois },
  ].filter(({ foto }) => foto?.url);

  if (!fotos.length) return null;

  return (
    <div className="fotos-equivalente-areia">
      {fotos.map(({ legenda, foto }) => (
        <figure key={legenda}>
          <img src={foto.url} alt={`Ensaio de equivalente de areia - ${legenda}`} />
          <figcaption>{legenda}</figcaption>
        </figure>
      ))}
    </div>
  );
}

function NotaCurva({ tipoAgregado }) {
  return (
    <div className="nota-curva">
      <div>NOTA:</div>
      <p>{notaCurvaGranulometrica(tipoAgregado)}</p>
    </div>
  );
}

function dadosIndiceForma(item) {
  const indiceForma = item.indiceForma;
  const indiceFormaObjeto =
    indiceForma && typeof indiceForma === "object" && !Array.isArray(indiceForma)
      ? indiceForma
      : null;
  const data = indiceFormaObjeto?.data || item.dataIndiceForma;
  const resultado = indiceFormaObjeto?.resultado || (!indiceFormaObjeto ? indiceForma : "") || item.indiceDeForma;
  const semEnsaio = indiceFormaObjeto ? indiceFormaObjeto.semEnsaio : false;

  return {
    data,
    resultado,
    mostrar: item.tipoAgregado === "graudo" || ensaioSolicitado(item, "caracterizacao-indice-forma"),
  };
}

function dadosAbrasaoLosAngeles(item) {
  const dados = item.abrasaoLosAngeles || item.losAngeles || item.abrasao || {};
  const data = item.dataAbrasaoLosAngeles || item.dataLosAngeles || dados.data;

  return {
    ...dados,
    data,
    mostrar:
      (item.tipoAgregado === "graudo" &&
        Boolean(
        data ||
          dados.massaInicial ||
          dados.massaFinal ||
          dados.graduacaoEnsaio ||
          dados.quantidadeEsferas ||
          dados.massaEsferas ||
          dados.abrasaoPercentual
        )) ||
      ensaioSolicitado(item, "caracterizacao-abrasao-los-angeles"),
  };
}

function TabelaAbrasaoLosAngeles({ item, numero }) {
  const los = dadosAbrasaoLosAngeles(item);
  if (!los.mostrar) return null;
  const possuiResultado = Boolean(los.data || los.abrasaoPercentual);

  return (
    <div className="bloco-ensaio-complementar">
      <Subtitulo numero={numero}>Ensaio de desgaste por Abrasão “Los Angeles”.</Subtitulo>
      <div className="data-ensaio-linha">Data do ensaio: <span>{formatarDataBR(los.data)}</span></div>
      <table className="tabela-ensaio-simples">
        <thead>
          <tr>
            <th>Graduação do Ensaio</th>
            <th>Abrasão “Los Angeles” (%)</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>Massa Inicial (g)</td><td>{valor(los.massaInicial)}</td></tr>
          <tr><td>Massa Final (g)</td><td>{valor(los.massaFinal)}</td></tr>
          <tr><td>Graduação do Ensaio</td><td>{valor(los.graduacaoEnsaio)}</td></tr>
          <tr><td>Quantidade de Esferas</td><td>{valor(los.quantidadeEsferas)}</td></tr>
          <tr><td>Massa das Esferas (g)</td><td>{valor(los.massaEsferas)}</td></tr>
          <tr><td>Abrasão Los Angeles (%)</td><td><strong>{valor(los.abrasaoPercentual)}</strong></td></tr>
        </tbody>
      </table>
      <p className="nota-ensaio">
        {possuiResultado
          ? "A ABNT NBR 7211/2022 especifica o limite máximo de 50% para a Abrasão “Los Angeles”, considerando o emprego do agregado graúdo na produção dos concretos. A amostra analisada atende as especificações da NBR 7211/2022 quanto ao ensaio realizado."
          : "Ensaio em andamento."}
      </p>
    </div>
  );
}

function TabelaParticulasLeves({ item, numero }) {
  const leves = item.particulasLeves || {};
  const possuiResultado = particulasLevesPreenchidas(leves);
  const mostrar =
    possuiResultado ||
    ensaioSolicitado(item, "caracterizacao-particulas-leves");
  if (!mostrar) return null;

  return (
    <div className="bloco-ensaio-complementar">
      <Subtitulo numero={numero}>Teor de Partículas Leves (Matérias Carbonosos)</Subtitulo>
      <div className="data-ensaio-linha">Data do ensaio: <span>{formatarDataBR(leves.data)}</span></div>
      <table className="tabela-ensaio-simples tabela-particulas-leves">
        <tbody>
          <tr>
            <td>TEOR DE PARTÍCULAS LEVES (%)</td>
            <td>{valor(leves.teor)}</td>
            <td>Massa Específica da Solução do ensaio</td>
            <td>{valor(leves.massaEspecificaSolucao)} (g/cm³)</td>
          </tr>
          <tr>
            <td rowSpan="3">Quantidade Máxima Relativa à Massa do Agregado (%)</td>
            <td colSpan="3">Limites: NBR 7211/09 - ASTM 123</td>
          </tr>
          <tr>
            <td colSpan="2">Concreto Aparente</td>
            <td>0,5</td>
          </tr>
          <tr>
            <td colSpan="2">Concreto Não Aparente</td>
            <td>1,0</td>
          </tr>
        </tbody>
      </table>
      <p className="nota-ensaio">
        {possuiResultado
          ? "A amostra analisada atende as especificações da ABNT NBR 7211/2022 quanto os ensaios realizados para Teor de partículas leves (materiais carbonosos)."
          : "Ensaio em andamento."}
      </p>
    </div>
  );
}

function TabelaSaisCloretosSulfatos({ item, numero }) {
  const sais = item.saisCloretosSulfatos || item.sais || {};
  const possuiResultado = Boolean(sais.data || sais.teorCloretos || sais.teorSulfatos || sais.teorSais);
  const mostrar = Boolean(
    sais.data ||
    sais.teorCloretos ||
    sais.teorSulfatos ||
    sais.teorSais ||
    ensaioSolicitado(item, "caracterizacao-sais-cloretos-sulfatos")
  );
  if (!mostrar) return null;

  return (
    <div className="bloco-ensaio-complementar">
      <Subtitulo numero={numero}>Determinação de Sais, Cloretos (Cl-) e Sulfatos Solúveis (SO42-)</Subtitulo>
      <div className="data-ensaio-linha">Data conclusão: <span>{formatarDataBR(sais.data)}</span></div>
      <table className="tabela-ensaio-simples">
        <thead>
          <tr><th colSpan="3">ENSAIOS</th></tr>
          <tr>
            <th>TEOR DE CLORETOS (%)</th>
            <th>TEOR DE SULFATOS (%)</th>
            <th>TEOR DE SAIS</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{valor(sais.teorCloretos)}</td>
            <td>{valor(sais.teorSulfatos)}</td>
            <td>{valor(sais.teorSais)}</td>
          </tr>
          <tr>
            <td>LIMITE NORMATIVO (CLORETO)</td>
            <td colSpan="2">&lt;0,2% para concreto simples, &lt;0,1 para concreto armado e &lt;0,01% para concreto protendido.</td>
          </tr>
          <tr>
            <td>LIMITE NORMATIVO (SULFATO)</td>
            <td colSpan="2">&lt;0,1%</td>
          </tr>
        </tbody>
      </table>
      <p className="nota-ensaio">
        Observação: {possuiResultado ? valor(sais.observacao || "Realizado em laboratório parceiro") : "Ensaio em andamento."}
      </p>
    </div>
  );
}

function tituloGraficoCurva(item, indice) {
  const amostra = String(item.amostra || "").trim().toLowerCase();
  const nomeMaterial = amostra || (item.tipoAgregado === "miudo" ? "areia" : "brita");
  return `Gráfico ${indice + 1}: Curva Granulométrica ${nomeMaterial} – Limites ABNT NBR 7211.`;
}

function CabecalhoRelatorioCaracterizacao({ relatorio }) {
  return (
    <>
      <table className="cabecalho cabecalho-modelo">
        <tbody>
          <tr>
            <td rowSpan="3" className="logo-cell">
              <LogoRelatorio alt="Logo" className="logo" />
            </td>
            <td className="titulo-sgq">SISTEMA DE GESTÃO DA QUALIDADE</td>
            <td className="codigo-cell">RQ 2.2.12</td>
          </tr>
          <tr>
            <td rowSpan="2" className="titulo-documento">Relatório de ensaio - Caracterização de agregados para concreto</td>
            <td>Revisão 00</td>
          </tr>
          <tr>
            <td>20/08/2025</td>
          </tr>
        </tbody>
      </table>

      <table className="linha-data-codigo">
        <tbody>
          <tr>
            <td><strong>DATA</strong> <span>{formatarDataBR(relatorio?.data)}</span></td>
            <td><strong>CÓDIGO:</strong> {relatorio?.codigoRelatorio || "-"}{relatorio?.numeroRevisao != null ? ` rev.${relatorio.numeroRevisao}` : ""}</td>
          </tr>
        </tbody>
      </table>
    </>
  );
}

function RodapeRelatorioCaracterizacao() {
  return (
    <div className="rodape-restrito">
      <div className="linha-rodape" aria-hidden="true" />
      <div>DOCUMENTO PARA USO RESTRITO. REPRODUÇÃO/CÓPIA PROIBIDA SEM AUTORIZAÇÃO DA EMPRESA</div>
    </div>
  );
}

function SecaoMaterial({ item, indice, espacosPaginacao = {} }) {
  const isMiudo = item.tipoAgregado === "miudo";
  const Chart = isMiudo ? ChartMiudo : ChartGraudo;
  const numeroBase = `3.${indice + 1}`;
  const abrasao = dadosAbrasaoLosAngeles(item);
  const leves = item.particulasLeves || {};
  const sais = item.saisCloretosSulfatos || item.sais || {};
  const ensaiosComplementares = [
    {
      mostrar: abrasao.mostrar,
      render: (numero) => <TabelaAbrasaoLosAngeles item={item} numero={numero} />,
    },
    {
      mostrar:
        particulasLevesPreenchidas(leves) ||
        ensaioSolicitado(item, "caracterizacao-particulas-leves"),
      render: (numero) => <TabelaParticulasLeves item={item} numero={numero} />,
    },
    {
      mostrar: Boolean(
        sais.data ||
        sais.teorCloretos ||
        sais.teorSulfatos ||
        sais.teorSais ||
        ensaioSolicitado(item, "caracterizacao-sais-cloretos-sulfatos")
      ),
      render: (numero) => <TabelaSaisCloretosSulfatos item={item} numero={numero} />,
    },
  ];

  return (
    <div className="material">
        <SecaoTitulo numero={numeroBase}>{isMiudo ? "AGREGADO MIÚDO" : "AGREGADO GRAÚDO"}</SecaoTitulo>
        <div className="linha-material">
          <strong>Material:</strong>{" "}
          {valor(item.amostra)} - {valor(item.procedencia)} - COD. {codigoMaterial(item)}
        </div>
        <div
          className="bloco-paginacao-inteira"
          data-bloco-paginacao={`granulometria-${item.id}`}
          style={{ paddingTop: `${espacosPaginacao[`granulometria-${item.id}`] || 0}px` }}
        >
          <Subtitulo numero={`${numeroBase}.1`}>Composição granulométrica</Subtitulo>
          <TabelaGranulometria item={item} />
        </div>
        <div
          className="bloco-curva-granulometrica bloco-paginacao-inteira"
          data-bloco-paginacao={`curva-${item.id}`}
          style={{ paddingTop: `${espacosPaginacao[`curva-${item.id}`] || 0}px` }}
        >
          <div className="titulo-grafico-curva">{tituloGraficoCurva(item, indice)}</div>
          <Chart
            linhas={item.granulometria || []}
            amostra={item.amostra}
            tipoAgregado={isMiudo ? "Miúdo" : "Graúdo"}
            faixasAdicionais={item.faixasAdicionais}
          />
          <NotaCurva tipoAgregado={item.tipoAgregado} />
        </div>
        <div
          className="bloco-paginacao-inteira"
          data-bloco-paginacao={`resultados-${item.id}`}
          style={{ paddingTop: `${espacosPaginacao[`resultados-${item.id}`] || 0}px` }}
        >
          <Subtitulo numero={`${numeroBase}.2`}>Resultados da Caracterização.</Subtitulo>
          <TabelaResultadosCaracterizacao item={item} />
        </div>
        {isMiudo && <FotosEquivalenteAreia item={item} />}
      {ensaiosComplementares
        .filter((ensaio) => ensaio.mostrar)
        .map((ensaio, ensaioIndex) => (
          <div
            key={`${numeroBase}-ensaio-${ensaioIndex}`}
            className="bloco-paginacao-inteira"
            data-bloco-paginacao={`complementar-${item.id}-${ensaioIndex}`}
            style={{ paddingTop: `${espacosPaginacao[`complementar-${item.id}-${ensaioIndex}`] || 0}px` }}
          >
            {ensaio.render(`${numeroBase}.${ensaioIndex + 3}`)}
          </div>
        ))}
    </div>
  );
}

export default function RelatorioCaracterizacaoPrint({
  relatorio,
  caracterizacoes,
  anexosEnsaios = [],
  cliente,
  obra,
  onVoltar,
  onSalvar,
  salvando = false,
  autoPrint = false,
}) {
  useNomeArquivoPdf(relatorio?.codigoRelatorio);
  const jaImprimiuRef = useRef(false);
  const paginaRef = useRef(null);
  const conteudoRef = useRef(null);
  const conteudoPreviaRef = useRef(null);
  const [anexosProntos, setAnexosProntos] = useState([]);
  const [quantidadePaginas, setQuantidadePaginas] = useState(1);
  const [alturaUtilPagina, setAlturaUtilPagina] = useState(0);
  const [espacosPaginacao, setEspacosPaginacao] = useState({});
  const anexosSelecionados = Array.isArray(relatorio?.anexos)
    ? relatorio.anexos.filter((anexo) => anexo?.selecionado && String(anexo?.texto || "").trim())
    : [];
  const gruposAnexos = anexosSelecionados
    .map((anexo, index) => ({
      numero: index + 1,
      id: anexo.id,
      titulo: anexo.texto,
      ensaios: anexosEnsaios.filter((item) => item.anexoId === anexo.id),
    }))
    .filter((grupo) => grupo.ensaios.length > 0);
  const caracterizacoesOrdenadas = [...caracterizacoes].sort((a, b) => {
    if (a.tipoAgregado !== b.tipoAgregado) return a.tipoAgregado === "graudo" ? -1 : 1;
    return (Number(codigoMaterial(a)) || 0) - (Number(codigoMaterial(b)) || 0);
  });

  const marcarAnexoPronto = useCallback((chave) => {
    setAnexosProntos((atuais) => (atuais.includes(chave) ? atuais : [...atuais, chave]));
  }, []);

  useEffect(() => {
    if (
      !autoPrint ||
      jaImprimiuRef.current ||
      anexosProntos.length < anexosEnsaios.length
    ) return;
    jaImprimiuRef.current = true;
    const frame = window.requestAnimationFrame(() => imprimir(relatorio?.codigoRelatorio));
    return () => window.cancelAnimationFrame(frame);
  }, [autoPrint, anexosEnsaios.length, anexosProntos.length, relatorio?.codigoRelatorio]);

  useEffect(() => {
    const pagina = paginaRef.current;
    const conteudo = conteudoRef.current;
    if (!pagina || !conteudo) return undefined;

    const atualizarQuantidadePaginas = () => {
      const larguraPagina = pagina.getBoundingClientRect().width;
      if (!larguraPagina) return;
      const conteudoMedido = conteudoPreviaRef.current || conteudo;
      const alturaPagina = larguraPagina * (297 / 210);
      const cabecalho =
        pagina
          .querySelector(".cabecalho-repetido-caracterizacao > tr > td")
          ?.getBoundingClientRect().height || 0;
      const rodape =
        pagina
          .querySelector(".rodape-restrito")
          ?.getBoundingClientRect().height || 0;
      const estilo = window.getComputedStyle(pagina);
      const espacoVertical = parseFloat(estilo.paddingTop) + parseFloat(estilo.paddingBottom);
      const pxPorMm = larguraPagina / 210;
      const espacoCabecalhoPreview = 6 * pxPorMm;
      const alturaUtil = Math.max(
        1,
        alturaPagina - cabecalho - rodape - espacoVertical - espacoCabecalhoPreview
      );

      const novosEspacos = {};
      const topoConteudo = conteudoMedido.getBoundingClientRect().top;
      const blocosInteiros = Array.from(
        conteudoMedido.querySelectorAll(".bloco-paginacao-inteira[data-bloco-paginacao]")
      );
      let ajusteAcumulado = 0;

      blocosInteiros.forEach((bloco) => {
        const chave = bloco.dataset.blocoPaginacao;
        if (!chave) return;

        const estiloBloco = window.getComputedStyle(bloco);
        const paddingAtual = parseFloat(estiloBloco.paddingTop) || 0;
        const rect = bloco.getBoundingClientRect();
        const topoBase = rect.top - topoConteudo + ajusteAcumulado;
        const alturaSemEspaco = Math.max(0, rect.height - paddingAtual);
        const posicaoNaPagina =
          ((topoBase % alturaUtil) + alturaUtil) % alturaUtil;
        const espacoRestante = alturaUtil - posicaoNaPagina;

        const devePular =
          alturaSemEspaco <= alturaUtil &&
          posicaoNaPagina > 0.5 &&
          alturaSemEspaco > espacoRestante + 0.5;

        novosEspacos[chave] = devePular ? espacoRestante : 0;
        ajusteAcumulado += novosEspacos[chave] - paddingAtual;
      });

      setEspacosPaginacao((atual) => {
        const chavesAtuais = Object.keys(atual);
        const chavesNovas = Object.keys(novosEspacos);
        const iguais =
          chavesAtuais.length === chavesNovas.length &&
          chavesNovas.every(
            (chave) => Math.abs((atual[chave] || 0) - (novosEspacos[chave] || 0)) < 0.5
          );

        return iguais ? atual : novosEspacos;
      });

      const alturaConteudoAjustada = Math.max(0, conteudoMedido.scrollHeight + ajusteAcumulado);
      const novaQuantidade = Math.max(1, Math.ceil(alturaConteudoAjustada / alturaUtil));

      setAlturaUtilPagina((atual) =>
        Math.abs(atual - alturaUtil) < 0.5 ? atual : alturaUtil
      );
      setQuantidadePaginas((atual) => (atual === novaQuantidade ? atual : novaQuantidade));
    };

    atualizarQuantidadePaginas();
    const observador = new ResizeObserver(atualizarQuantidadePaginas);
    observador.observe(conteudo);
    window.addEventListener("resize", atualizarQuantidadePaginas);
    return () => {
      observador.disconnect();
      window.removeEventListener("resize", atualizarQuantidadePaginas);
    };
  }, [alturaUtilPagina, caracterizacoesOrdenadas.length, relatorio]);

  const conteudoPrincipalRelatorio = (
    <>

        <div className="faixa-cinza"></div>

        <div className="bloco-empresa">
          <div><strong>EMPRESA/CONTRATANTE:</strong> <span>{cliente?.nome || relatorio?.clienteNome || "-"}</span></div>
          <div><strong>ENDEREÇO:</strong> <span>{obra?.nome || relatorio?.obraNome || "-"}</span></div>
        </div>

        <div className="faixa-relatorio-ensaio">RELATÓRIO DE ENSAIO</div>

        <div
          className="bloco-paginacao-inteira"
          data-bloco-paginacao="objetivo"
          style={{ paddingTop: `${espacosPaginacao.objetivo || 0}px` }}
        >
        <SecaoTitulo numero="1.0">OBJETIVO</SecaoTitulo>
        <p className="texto">
          Apresentar os resultados dos ensaios dos agregados cadastrados para a obra selecionada,
          conforme o item 2.1 deste relatório.
        </p>
        </div>

        <div
          className="bloco-paginacao-inteira"
          data-bloco-paginacao="metodologia"
          style={{ paddingTop: `${espacosPaginacao.metodologia || 0}px` }}
        >
        <SecaoTitulo numero="2.0">METODOLOGIA</SecaoTitulo>
        <p className="texto">
          Os resultados foram consolidados a partir dos registros de ensaio armazenados no sistema, respeitando os
          procedimentos internos de cadastro e as normas indicadas em cada ensaio. As tabelas reproduzem os valores
          informados e calculados nas fichas de caracterização dos materiais selecionados.
        </p>
        </div>

        <div
          className="bloco-paginacao-inteira"
          data-bloco-paginacao="normas"
          style={{ paddingTop: `${espacosPaginacao.normas || 0}px` }}
        >
        <Subtitulo numero="2.1">Ensaios solicitados/realizados e normas de referência</Subtitulo>
        <table className="tabela-compacta tabela-normas-referencia">
          <tbody>
            {normasReferenciaRelatorio(caracterizacoes).map((linha, index) => (
              <tr key={`${linha.codigo}-${index}`}>
                <td>{linha.codigo}</td>
                <td>{linha.descricao}</td>
              </tr>
            ))}
          </tbody>
        </table>

        </div>
        <div
          className="bloco-paginacao-inteira"
          data-bloco-paginacao="amostras"
          style={{ paddingTop: `${espacosPaginacao.amostras || 0}px` }}
        >
        <SecaoTitulo numero="3.0">IDENTIFICAÇÃO DAS AMOSTRAS</SecaoTitulo>
        <table className="tabela-compacta">
          <thead>
            <tr className="subtitulo">
              <th>Código</th>
              <th>Amostra</th>
             <th>Local Coleta</th>
              <th>Procedência</th>
          
            </tr>
          </thead>
          <tbody>
            {caracterizacoesOrdenadas.map((item) => (
              <tr key={item.id}>
                <td>{codigoMaterial(item)}</td>
                <td>{valor(item.amostra)}</td>
                <td>{valor(item.procedencia)}</td>
                <td>{valor(item.localColeta)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        </div>

        {caracterizacoesOrdenadas.map((item, indice) => (
          <SecaoMaterial
            key={item.id}
            item={item}
            indice={indice}
            espacosPaginacao={espacosPaginacao}
          />
        ))}

        {anexosSelecionados.length > 0 && (
          <div
            className="secao-anexos bloco-paginacao-inteira"
            data-bloco-paginacao="lista-anexos"
            style={{ paddingTop: `${espacosPaginacao["lista-anexos"] || 0}px` }}
          >
            <SecaoTitulo numero="5.0">ANEXOS.</SecaoTitulo>
            <div className="lista-anexos">
              {anexosSelecionados.map((anexo, index) => (
                <div key={anexo.id || `${anexo.texto}-${index}`}>
                  Anexo {index + 1} - {anexo.texto};
                </div>
              ))}
            </div>
          </div>
        )}

        <div
          className="bloco-paginacao-inteira"
          data-bloco-paginacao="consideracoes-finais"
          style={{ paddingTop: `${espacosPaginacao["consideracoes-finais"] || 0}px` }}
        >
        <SecaoTitulo numero={anexosSelecionados.length > 0 ? "6.0" : "4.0"}>
          CONSIDERAÇÕES FINAIS
        </SecaoTitulo>
        <p className="texto">
          Os resultados apresentados correspondem aos dados cadastrados nos ensaios de caracterização vinculados ao
          cliente e à obra selecionados. Campos sem informação no cadastro são apresentados com traço.
        </p>
        </div>

    </>
  );

  return (
    <>
    <div className="relatorio-caracterizacao-geral-print">
      <div className="acoes-print">
        <button className="btn-voltar" onClick={onVoltar}>Voltar</button>
        {onSalvar && (
          <button className="btn-imprimir" onClick={onSalvar} disabled={salvando}>
            {salvando ? "Salvando..." : "Salvar relatório"}
          </button>
        )}
        <button
          className="btn-imprimir"
          onClick={() => imprimir(relatorio?.codigoRelatorio)}
        >
          Imprimir
        </button>
      </div>

      <div
        className="pagina pagina-conteudo-continuo pagina-fonte-paginacao"
        ref={paginaRef}
        style={{ "--altura-paginas": `${quantidadePaginas * 297}mm` }}
      >
        <table className="estrutura-relatorio-print">
          <thead className="cabecalho-repetido-caracterizacao">
            <tr><td><CabecalhoRelatorioCaracterizacao relatorio={relatorio} /></td></tr>
          </thead>
          <tfoot className="rodape-repetido-caracterizacao">
            <tr><td><RodapeRelatorioCaracterizacao /></td></tr>
          </tfoot>
          <tbody>
            <tr>
              <td>
                <div className="conteudo-relatorio-caracterizacao" ref={conteudoRef}>
                  {conteudoPrincipalRelatorio}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="paginas-preview-reais" aria-label="Pré-visualização paginada do relatório">
        {alturaUtilPagina > 0 &&
          Array.from({ length: quantidadePaginas }, (_, indicePagina) => (
            <section className="pagina-preview-real" key={`pagina-preview-${indicePagina}`}>
              <div className="cabecalho-preview-real">
                <CabecalhoRelatorioCaracterizacao relatorio={relatorio} />
              </div>

              <div
                className="conteudo-preview-real"
                style={{ height: `${alturaUtilPagina}px` }}
              >
                <div
                  className="conteudo-preview-real-deslocado"
                  ref={indicePagina === 0 ? conteudoPreviaRef : undefined}
                  style={{
                    transform: `translateY(-${indicePagina * alturaUtilPagina}px)`,
                  }}
                >
                  {conteudoPrincipalRelatorio}
                </div>
              </div>

              <RodapeRelatorioCaracterizacao />
            </section>
          ))}
      </div>
    </div>
   {gruposAnexos.map((grupo) => (
  <React.Fragment key={grupo.id}>
    <div className="pagina-anexo-caracterizacao">
      <FolhaRostoAnexo
        numero={grupo.numero}
        titulo={grupo.titulo}
        ensaios={grupo.ensaios}
        relatorio={relatorio}
        cliente={cliente}
        obra={obra}
      />
    </div>

    {grupo.ensaios.map((anexo, index) => {
          const chave = `${anexo.tipo}-${anexo.ensaio.id}-${index}`;
          const classeAnexo =
            anexo.tipo === "mescla-granulometrica-cbuq"
              ? "relatorio-anexo-completo relatorio-anexo-mescla"
              : "relatorio-anexo-completo";
          return (
            <div className={classeAnexo} key={chave}>
              {anexo.tipo === "raa" && (
                <RelatorioRAAPrint
                  ensaio={anexo.ensaio}
                  leituras={anexo.leituras || []}
                  onReady={() => marcarAnexoPronto(chave)}
                />
              )}
              {anexo.tipo === "adesividade" && (
                <RelatorioAdesividadePrint
                  ensaio={anexo.ensaio}
                  onReady={() => marcarAnexoPronto(chave)}
                />
              )}
              {anexo.tipo === "mescla-granulometrica-cbuq" && (
                <RelatorioMescla
                  dados={anexo.ensaio}
                  onReady={() => marcarAnexoPronto(chave)}
                  modoAnexo
                />
              )}
            </div>
          );
        })}
      </React.Fragment>
    ))}
    </>
  );
}
